import keys from '@debbie/common/dist/cache/keys.js';
import { isAdmin } from '@debbie/common/dist/permissions/index.js';
import * as api from '../api/me.js';
import { h } from '../index.js';
import q from '../query.js';
import { useTenantId } from '../tenant/selected.js';
export const meEntity = 'me';
const meKey = 'me';
export const useMe = () => q.query(meKey, api.get, keys.read.collection(meEntity));
export const useMeTenant = () => {
    const meLoadable = useMe();
    const tenantId = useTenantId();
    if (!h.isLoaded(meLoadable) || tenantId == null) {
        return null;
    }
    return (meLoadable.data.tenants.find((tenant) => tenant.id === tenantId) || null);
};
export const useTenantById = (id) => {
    const me = useMe();
    const tenantId = useTenantId();
    if (!h.isLoaded(me) || tenantId == null) {
        return null;
    }
    return me.data.tenants.find((tenant) => tenant.id === id) || null;
};
export const useRole = () => {
    const me = useMe();
    const tenantId = useTenantId();
    if (!h.hasData(me) || tenantId == null) {
        return null;
    }
    const role = me.data.tenants.find((tenant) => tenant.id === tenantId);
    return role?.role || null;
};
export const useIsAdmin = () => {
    const role = useRole();
    return role && isAdmin(role);
};
//# sourceMappingURL=index.js.map